import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import {Remove} from "../../../../controllers/projects"
export const FETCH_DELETE_PROJECTS_REQUEST = 'FETCH_DELETE_PROJECTS_REQUEST';
export const FETCH_DELETE_PROJECTS_SUCCESS = 'FETCH_DELETE_PROJECTS_SUCCESS';
export const FETCH_DELETE_PROJECTS_FAILURE = 'FETCH_DELETE_PROJECTS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDeleteProjectsRequest = () => {
    return {
        type: FETCH_DELETE_PROJECTS_REQUEST,
    };
};

const fetchDeleteProjectsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DELETE_PROJECTS_SUCCESS,
        payload: data
    };
};

const fetchDeleteProjectsFailure = (error: any) => {
    return {
        type: FETCH_DELETE_PROJECTS_FAILURE,
        payload: error,
    };
};

export const remove = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDeleteProjectsRequest());
        try {
            await Remove(id);
            dispatch(fetchDeleteProjectsSuccess(true));
        } catch (error: any) {
            dispatch(fetchDeleteProjectsFailure(error.message));
        }
    };
};
